import getURLParameter from './getURLParameter'
import $ from 'jquery'
import randomString from './getGuid';

/**
 * 封装频繁发起400电话请求时弹出验证码输入框的相关逻辑封装
 * @type {{responseData: {clientType: number, action: string, responseid: string, verifycode: string}, drawVerifyInput: drawVerifyInput, bindVerifyEvent: bindVerifyEvent, checkVerifyCode: checkVerifyCode}}
 */
var getPhone = {

    /**
     *  校验验证图片验证码时传入的参数对象
     */
    responseData: {
        clientType: 6,  // 6表示联盟
        action: 'checkVC',  // 操作为检验验证码操作
        responseid: '',  // 请求400电话失败，返回的responseid参数
        verifycode: ''  // 用户输入的验证码
    },
    /**
     * 生成校验图片验证码弹窗
     * @param {string} id  responseId
     * @returns {string}  校验图片验证码弹窗DOM结构字符串
     */
    drawVerifyInput: function (id) {
        // 生成图片验证码弹出框的DOM结构
        var verifyInputHTML = ''
            + '<div class="cover">'
            +     '<div class="verify-box">'
            +         '<h3 class="verify-box-title">您拨打电话过于频繁，请输入下方图片验证码</h3>'
            +         '<div class="verify-form">'
            +             '<input type="text" name="verifycode" placeholder="输入图片验证码">'
            +             '<img id="fresh-piccode" src="http://cheapi.58.com/api/phone/verifycode/pic?responseId='+ id +'&v=' + (new Date()).getTime() + '" alt="点击刷新">'
            +         '</div>'
            +         '<p id="verify-err" class="verify-err"></p>'
            +         '<div class="verify-box-btn">'
            +             '<button class="cancel-verify">取消</button>'
            +             '<button class="confirm-verify">确认</button>'
            +         '</div>'
            +     '</div>'
            + '</div>'

        return verifyInputHTML
    },
    /**
     * 绑定图片验证码输入弹窗的相关事件
     * @param {Object} $el  弹窗对象
     */
    bindVerifyEvent: function ($el, infoId) {
        var This = this
        /**
         * 刷新图片验证码
         */
        $el.find('#fresh-piccode').off('touchend').on('touchend', function () {
            // 获取图片验证码的图片链接
            var imgUrl = $('#fresh-piccode').attr('src').split('&v=')
            // 改变图片验证码的v参数，避免图片验证码缓存
            $('#fresh-piccode').attr('src', imgUrl[0] + '&v=' + (new Date()).getTime())
            // 清除错误提示
            $('#verify-err').empty()
        })

        /**
         * 取消验证事件绑定
         */
        $el.find('.cancel-verify').off('touchend').on('touchend', function () {
            // 移除弹窗
            $el.remove()
        })

        /**
         * 点击确定，提交验证码
         */
        $el.find('.confirm-verify').off('touchend').on('touchend', function () {

            // 调用checkVerifyCode方法，前端校验成功时，向后端发起请求
            if (This.checkVerifyCode()) {
                /**
                 * 校验验证码，验证码验证成功的回调函数
                 * @param {string} res 成功获得的400电话
                 */
                var succFunc = function (res) {
                    $el.remove()
                    // 当status为1时，返回400电话，调起拨打电话功能
                    window.location.href = 'tel:' + res
                }
                /**
                 * 验证码校验失败，返回新的responseid，刷新图片验证码，展示错误提示
                 * @param res
                 */
                var failFunc = function (res) {
                    // 获得新的responseid时，更新responseData的responseid参数，并清除verifycode的值
                    This.responseData.responseid = res.responseid
                    This.responseData.verifycode = ''
                    // 刷新图片验证码
                    $('#fresh-piccode').attr('src','http://cheapi.58.com/api/phone/verifycode/pic?responseId='+ res.responseid +'&v=' + (new Date()).getTime())
                    $('#verify-err').text('验证码输入错误，请重新输入')
                }

                // 向后端发起校验图片验证码的请求
                $.ajax({
                    type: 'get',
                    url: 'http://cheapi.58.com/api/detail/phone/get/' + infoId,
                    data: This.responseData,
                    dataType: 'jsonp',
                    success: function (data) {
                        // 校验成功时，status返回1，result为400电话
                        if (data.status == 1 && data.result) {
                            succFunc(data.result)
                            // 验证码校验通过埋点
                            clickLog('from=400frequentreq-passed-escdtl')
                        }
                        // 校验失败时status返回3，result中包含新的responseid
                        else if (data.status == 3 && data.result && data.result.responseid) {
                            failFunc(data.result)
                        }

                    },
                    error: function (err) {
                        // alert("网络错误！");
                        alert(JSON.stringify(err))
                    }
                })
            }
        })
    },
    /**
     * 当用户点击确定按钮时，前端对用户输入值得校验
     * @returns {boolean} 用户输入为空或不为4位字符时，返回false，用户输入字符为4位时，返回true
     */
    checkVerifyCode: function () {
        var This = this

        // 获取用户输入的验证码
        var verifycode = $('input[name="verifycode"]').val()

        // 清空错误提示
        $('#verify-err').empty()


        if (!$.trim(verifycode)) {
            // 如果输入值为空
            $('#verify-err').text('请输入图片验证码')
            return false
        }
        else if (verifycode.length !== 4) {
            // 如果输入的验证码不为4位
            $('#verify-err').text('请输入正确的图片验证码')
            return false
        }
        else {
            // 前端校验通过，更新responseData对象的verifycode
            This.responseData.verifycode = verifycode
            return true
        }
    }

}


//获取400电话号码，获取成功则调起拨打电话服务，如果频繁访问，则返回responseId，需用户输入验证码
function getTelbyInfoId(infoId) {
    //接口地址，后需要拼接infoId
    var dataUrl = '//cheapi.58.com/api/detail/phone/get/',
        urlProps = getURLParameter()

    /**
     * 获取400电话
     */
    $.ajax({
        url: dataUrl + infoId,
        data: {
            clientType: 6,  // 6表示联盟
            sourceKey: urlProps['sourceKey'] ? decodeURIComponent(urlProps['sourceKey']) : '',
            cid: urlProps['cid'] ? decodeURIComponent(urlProps['cid']) : ''
        },
        dataType: 'jsonp',
        success: function(data) {
            // 调取数据成功返回数据
            // 示例 {"msg":"成功","result":"40088814","status":1}
            // 当请求400达到设置的限制次数时，返回: {"msg":"成功","result":{"ct":"31510861173968092","encryptStr":"520f9164bccb492f8279c56365d56bbddex","responseid":"aade3ce9c7654ab4b8a68a5ee808bd4c"},"status":2}

            // 校验返回的status，判断用户拿到的返回数据是电话号码还是responseId
            if(data.status == 1 && data.result) {
                // 当status为1时，返回400电话，调起拨打电话功能
                window.location.href = 'tel:' + data.result

            }
            else if (data.status == 2 && data.result && data.result.responseid) {
                // 当status为2时，即有返回的responseid
                getPhone.responseData.responseid = data.result.responseid
                // 定义弹窗对象
                var $verifyPop = $(getPhone.drawVerifyInput(data.result.responseid))
                // 渲染弹窗
                $('body').append($verifyPop)
                // 绑定弹窗中元素的相关事件
                getPhone.bindVerifyEvent($verifyPop, __lm_info.infoId)
            }
            else {
                alert('暂时联系不到TA，请稍后再试')
            }
        },
        error: function() {
            alert('暂时联系不到TA，请稍后再试')
        },
        complete: function () {
            // 请求400电话埋点
            clickLog('from=400frequentreq-escdtl')
        }
    })
}

//黄页类目拨打电话弹窗
function Huangye400Pop(phoneNum, source) {
    this.phoneNum = phoneNum
    this.source = source
    this.hash = '400pop'
    this.init()
}
Huangye400Pop.prototype.init = function() {
    var _this = this
    var dom = ''
        +'<div class="ws-cover">'
        +   '<div class="ws-tel-main">'
        +       '<p class="ws-count-down">电话<span id="ws-second">180</span>S后失效</h>'
        +       '<div class="ws-phone-num">' + this.formatPhoneNum() + '</div>'
        +       '<p class="ws-note">此号码暂不支持短信收发功能！</p>'
        +       '<div id="ws-tel"><span>立即拨打</span></div>'
        +   '</div>'
        +   '<i class="ws-close"></i>'
        +'</div>'
    var parent = $(dom)
    // window.location.hash = this.hash;
    // alert('this:'+this.hash)
    // alert('window:'+window.location.hash)
    this.bindEvent(parent)
    $('body').append(parent)
}
Huangye400Pop.prototype.bindEvent = function($parent) {
    var that = this
    var count = $parent.find('#ws-second').html()
    function countDown() {
        if(count === 0) {
            $parent.remove()
            return
        }
        $parent.find('#ws-second').html(--count)
    }
    var countDownId = setInterval(countDown, 1000)
    $parent.off('touchmove').on('touchmove', function(e) {
        e.preventDefault()
    })
    $parent.find('.ws-close').off('click').on('click', function(e) {
        clearInterval(countDownId)
        // window.history.go(-1);
        $parent.remove()
        e.preventDefault()
    })
    $parent.find('#ws-tel').off('click').on('click', function(e) {
        clickLog('400popupcall-' + (that.source===1? 'list' : 'dtl'))
        // window.history.go(-1);
        window.location.href = 'tel:' + that.phoneNum
        clearInterval(countDownId)
        $parent.remove()
        e.preventDefault()
    })
    setTimeout(function(){
        window.onhashchange = function(e) {
            if (window.location.hash !== this.hash){
                $parent.remove()
            }
        }
    }, 0)
}
Huangye400Pop.prototype.formatPhoneNum = function() {
    return this.phoneNum
        // ? this.phoneNum.replace(/(...)(....)(.*?)/g, '$1-$2-$3')
        ? this.phoneNum
        : '命中防刷'
}

let call_huangye400 = function(infoId, uniquesign, source, url, adtype, slot, pos, sid, busInfo, busTransInfo) {
    let urlPara = getURLParameter(url)
    let cid = randomString()
    $.ajax({
        url: '//link.58.com/api/assign',
        data: {
            infoId: infoId,         /*帖子id*/
            platform: 1,            /*M端*/
            clientId: 2,            /*接入方id*/
            uniqueSign: uniquesign, /*请求标识，防刷*/
            channel: 1,             /*联盟*/
            source: source,         /*分配渠道，1-列表页，2-详情页*/
            infoType: 0,            /*帖子*/
            slot: slot || urlPara['slot'],
            adtype: adtype || urlPara['adtype'],
            pos: pos || urlPara['pos'],
            cid: cid || urlPara['cid'],
            sid: sid ||urlPara['psid'],
            busInfo,
            busTransInfo
        },
        dataType: 'jsonp',
        success: function(data) {
            if (data.code !== 4) {
                var dispid = ____json4fe.catentry[0].dispid
                if ( ['4'].indexOf(dispid) === -1) {  //排除二手车4，二手市场5一级分类，仅黄页弹窗
                    // todo 弹窗展现
                    clickLog('from=400popupshow-' + (source===1? 'list' : 'dtl'))
                    new Huangye400Pop(data.result, source)
                } else {
                    window.location.href = 'tel:' + data.result
                }
            } else {
                alert('暂时联系不到TA，请稍后再试')
            }
        },
        error: function() {
            alert('暂时联系不到TA，请稍后再试')
        },
        complete: function () {
            // 请求400电话埋点
            clickLog('from=400frequentreq-escdtl')
            setTimeout(function(){
                //电话调起请求完成
                window.telLoading = false
            },100)
        }
    })
}

function lunaLog (url, useCache) {
    var img = new Image,
        key = '_phone_log_' + Math.floor(1e4 * Math.random())
    window[key] = img,
        img.onload = img.onerror = img.onabort = function() {
            img.onload = img.onerror = img.onabort = null,
                window[key] = null,
                img = null
        },
        img.src = url + (useCache ? '': (url.indexOf('?') > 0 ? '&': '?') + key)
}

//模块接口
let use400 = {
    //详情页使用
    telForDetail: function(elements,infoId) {
        $(elements).on('touchend', function() {
            getTelbyInfoId(__lm_info.infoId)
        })
    },
    //列表页使用,使用事件代理
    telForList: function(list, elements) {
        $(list).on('touchend', elements, function(e) {
            var infoId = $(this).data('infoid')
            var infoType = $(this).data('infotype')
            //判断是不是自主建站（infoType!=0），如果是不调用400接口
            if(infoType != '0') {
                window.location.href = 'tel:' + $(this).data('tel')
            } else {
                getTelbyInfoId(infoId)
            }
            // lunaLog(chargingUrl);
        })
    },
    huangye400: function (para) {
        let infoId = para.infoId,
            uniquesign = para.uniquesign,
            source = para.source,
            url = para.url,
            adtype = para.adtype,
            slot = para.slot,
            pos = para.pos,
            sid = para.sid;
            busInfo = para.busInfo,
            busTransInfo = para.busTransInfo
        if (source === 2) {
            call_huangye400(infoId, uniquesign, source, location.href, adtype, slot, pos, sid, busInfo, busTransInfo)
        } else {
            call_huangye400(infoId, uniquesign, source, url, adtype, slot, pos, sid, busInfo, busTransInfo);
            let _img = document.createElement("img");
            _img.src = url;
        }
    },
    getTelbyInfoId: (infoId) => {
        getTelbyInfoId(infoId)
    }
}
export default use400